import { Level } from 'pino';

import { logger } from '../services/logger';

export const log = (level: Level, message: string) => (data: Record<string, unknown>) =>
  logger[level]({ ...data }, message);
